<template>
  <section class="travel-insurance-section">
    <DynamicCalculator :data="data" />
  </section>
</template>

<script>
import DynamicCalculator from "./DynamicCalculator.vue";

export default {
  props: ["contentData"],
  components: {
    DynamicCalculator
  },
  data() {
    return {
      data: {
        axiosLink: "getCalcTravel",
        formType: "travel",
        header: _.get(this.contentData, "conf.header"),
        priceTitle: "პოლისის ღირებულება"
        // customParams: {
        //   Multy: "false"
        // }
      }
    };
  }
};
</script>
<style lang="scss">
.travel-insurance-section {
  .dynamic-calculator {
    .dynamic-content {
      padding: 20px 30px 55px;
    }
    &__form {
      position: relative;
      padding: 0px 0px 55px;
      .input-grid {
        margin-right: 0px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          .el-date-editor.el-input {
            width: 100%;
          }
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3) {
            width: 32%;
            @media (max-width: 1023px) {
              width: 100%;
            }
          }
          &:nth-child(4) {
            width: 66%;
            .el-input__inner {
              width: 100%;
              padding: 3px 15px;
            }
          }
          &:nth-child(5) {
            width: 32%;
          }
          @media (max-width: 767px) {
            width: 100% !important;
          }
          .el-range-separator {
            position: relative;

            &::after {
              position: absolute;
              top: 50%;
              transform: translate(0px, -50%);
              content: "";
              width: 1px;
              height: 80%;
              background-color: #dadada;
            }
          }
          .el-date-editor .el-range-input {
            text-align: left;
          }
        }
      }
    }
    .el-button {
      position: absolute;
      bottom: -10px;
      @media (max-width: 767px) {
        width: 100%;
      }
    }
  }
}
</style>
